<template>
  <div class="footer">
    <div class="footer_content">
      <div class="f_c_img">
        <img class="logo" src="@/images/safetyadm/logo.png" alt="디지몽 로고">
      </div>
      <div class="f_c_txt">
        대표이사 : 이명원  | 사업자등록번호 :  806-535-4991 | 주소 : 서울시 금천구 가산디지털로2로 98, 9층 1-905호(가산동,IT캐슬) <br>
        고객센터 : 평일(공휴일 휴무) 9:00 ~ 18:00  | ceo@pinostory.com <br>
        Copyright Pinostory Corporation, All Right Recerved<br>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
  export default {
    name: "PageFooter",
    mixins: [],
    data(){
      return{
      }
    },
    created() {
    },
    computed: {
    },

    mounted() {
    },
    methods: {
    },
  }
</script>
